
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import { useCookieState } from "use-cookie-state";

export default function Tutorial() {
  const [tutorial, setTutorial] = useCookieState('tutorial')

  React.useEffect(() => {
    if(!tutorial){
      setTutorial(true)
    }
  }, [tutorial])

  return (
    <main style={{ padding: "1rem 5rem", textAlign: "left", fontSize: "1.05rem" }}>
      <h1 style={{ textAlign: "center", fontSize: "1.3rem" }}>Instructions</h1>
      <p style={{ textAlign: "center", fontSize: "1.3rem" }}>Instructions to complete the survey</p>
      <p></p>


      <div className="panel panel-success">
        <Divider><h2>Task Information:</h2></Divider>
        <p>In this task, we will ask you to browse social media platforms with an installed extension, and then classify Ad Interests and Ads.
        </p>
        <div className="panel-body">
          <b>Task Requirements:</b>
          <ul>
            <li>1) Your desktop browser needs to be <span><b>Chrome</b></span><span><b>.</b></span></li>
            <li>2) <strong>All </strong>sections must be completed</li>
            <li>3) Be logged in to your <b>Google</b> account in your browser.</li>
            <li>4) Have an account and be logged in, to at least two of the following platforms: Facebook, Twitter, LinkedIn. </li>
            <li>5) <b>Disable</b> any Ad Blocker</li>
          </ul>

          <p><span><b>Estimated Time: </b>40</span> to 60 minutes
          </p>
          <b>Sections:</b>
          <ul>
            <li>1) Check Ad Settings</li>
            <li>2) Download Chrome Extension</li>
            <li>3) Browse platforms</li>
            <li>4) Classify interests</li>
            <li>5) Classify Ads</li>
            <li>6) Insert Completion Code</li>
          </ul>
          <strong>Chrome Extension description: </strong>This web extension: <u>Overprofiling</u>, collects Ads from Social Networks and interests associated with your accounts on several platforms. We will ask you to install this in your browser, browse several platforms, and collect ads. Then, we will ask you to rate interests and classify ads.
          <br />
          <br />
          The data will only be used for research purposes.
          <br />
          <br />
          <table className="table table-bordered">
            <tbody>
            </tbody>
          </table>
        </div>
      </div>
      <div className="panel panel-primary">
        <Divider><h2>1 - Check Ad settings</h2></Divider>
        <div className="panel-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="panel panel-info">

                <div>
                  <div>Before installing the extension, you should check whether you have logged in and whether you have interests activated in each platform:
                    <br />
                    It's <b>important</b> to check all settings are on, to avoid having issues regarding the collection of data.
                    <br />
                  </div>
                  <Grid container spacing={2} style={{ textAlign: "center" }}>
                    <Grid item xs={6}>
                      <b>Facebook</b>
                      <br />
                      <img alt="" height="250" src="https://eupoliticalbarometer.uc3m.es/overprofiling/AdSettingsFacebook.com.png" />
                      <br />
                      Check with this URL: <a href="https://www.facebook.com/adpreferences/ad_settings" target="_blank" rel="noreferrer" style={{ color: "white" }}>https://www.facebook.com/adpreferences/ad_settings</a>
                    </Grid>
                    <Grid item xs={6}>
                      <b>Google</b>
                      <br />
                      <img alt="" height="250" src="https://eupoliticalbarometer.uc3m.es/overprofiling/AdSettingsGoogle.png" width="698" />
                      <br />
                      Check with this URL: <a href="https://myadcenter.google.com" target="_blank" rel="noreferrer" style={{ color: "white" }}>https://myadcenter.google.com</a>
                    </Grid>
                    <Grid item xs={6}>
                      <b>Twitter </b>
                      <br />
                      <img alt="" height="250" src="https://eupoliticalbarometer.uc3m.es/overprofiling/AdSettingsTwitter.png" width="608" />
                      <br />
                      Check with this URL: <a href="https://twitter.com/settings/ads_preferences" target="_blank" rel="noreferrer" style={{ color: "white" }}>https://twitter.com/settings/ads_preferences</a>
                    </Grid>
                    <Grid item xs={6}>
                      <b>LinkedIn</b>
                      <br />
                      <img alt="" height="217" src="https://eupoliticalbarometer.uc3m.es/overprofiling/AdSettingsLinkedIn.png" width="727" />
                      <br />
                      Check with this URL: <a href="https://www.linkedin.com/mypreferences/d/interest-categories" target="_blank" rel="noreferrer" style={{ color: "white" }}>https://www.linkedin.com/mypreferences/d/interest-categories</a>
                    </Grid>
                  </Grid>
                </div>
                <div className="panel panel-info">
                  <Divider><h2>2 - Setup Extension</h2></Divider>
                  <div className="panel-body">
                  <p style={{marginBottom: 40}}>
                    <b>Note: </b>Step 4 is important to link the extension to your Prolific account, see the instructions of this section before starting to fill fields.
                  </p>
                    <p><span><strong>Step 1:</strong> Visit the Chrome Web Store link of the extension:</span>
                    </p>
                    <strong><a href="https://chrome.google.com/webstore/detail/overprofiling/mnmnepgfknlklcegefknonnpdaafmgcb" target="_blank" rel="noreferrer" style={{ color: "white" }}>Click here</a></strong>
                    <br />
                    <br />
                    <span><b>Step 2: </b>Install the extension:</span>
                    <br />
                    <br />
                    <img className="img-zoom" data-zoomtype="window" height="360" alt="extension instalations" src="https://eupoliticalbarometer.uc3m.es/overprofiling/Tutorial1.png" />
                    <br />
                    <br />
                    <br />
                    <img alt="" height="370" src="https://eupoliticalbarometer.uc3m.es/overprofiling/Tutorial2.png" />
                    <p>
                      <br />
                      <span><b>Step 3:</b> Once the extension is installed, a tab will open, and you have to verify that you are an adult, then read and accept the terms</span>
                      <br />
                      <br />
                      <img alt="" height="340" src="https://eupoliticalbarometer.uc3m.es/overprofiling/Tutorial3.png" width="563" />
                      <br />
                      <br />
                      <strong>Step 4</strong>: Fill out the demographic form and your <b>Prolific ID</b>. It is really important to fill your Prolific ID, as this is needed to receive the Completion Code and to be able to rank the task as complete.
                      <br />
                      <br />
                      <img alt="" height="340" src="https://eupoliticalbarometer.uc3m.es/overprofiling/Tutorial4b.png" width="519" />
                      <br />
                      <br />
                      <strong>Step 5:</strong> Pin the extension in the chrome toolbar: click on the Extensions Icon at the right side of the toolbar, and then click on the pushpin icon next to Overprofiling.
                    </p>
                    <p style={{fontSize: "1.15rem"}}>
                      {/*
                      <b>IMPORTANT:</b> Once you have installed the extension, do not classify the interests directly, first, complete the step 3. Demographic data should be shown to you (with options to answer yes or no), if they do not appear in a few seconds, check that you are connected to your google account, and then restart the browser. If they do not appear after restarting the browser, you can continue the study.
                      */}

                    </p>
                  </div>
                </div>
                <div className="panel panel-info">
                  <Divider><h2>3 - Browse platforms</h2></Divider>
                  <div className="panel-body"><strong>Estimated time:</strong> 20 - 30 minutes
                    <br />
                    Browse your Facebook, Twitter and LinkedIn <strong>feeds </strong>for a few minutes each (<b>do not browse YouTube</b>). You could also visit regular websites that display ads.
                    <br />
                    <b>You should not go too quickly</b> or ads may not be shown to you, and it will take you more time than necessary.
                    <br />
                    The extension needs to collect at least <strong><u>60 ads</u></strong>, make sure to collect <u>at least 10 ads from each platform you have an account. (Twitter, Facebook or LinkedIn). </u>
                    <br />
                    <p>
                    Once every few minutes, try to reload the page from any of the social networks, to make sure that the extension work properly.
                    </p>

                    <p>
                    <strong>Note:</strong> We advise you to start with <b>Facebook</b>, as the ads from this platform will take more time to collect. You will see that some facebook tabs are being open in the background, we only can do this every 30 seconds, so take this into consideration. If you already have 10 ads from Facebook, go to another platform.
                    </p>
                    <br />
                    You can check the number of ads in the Ads Collected Tab:
                    <br />
                    <br />
                    <img alt="Ads collected tab" height="340" src="https://eupoliticalbarometer.uc3m.es/overprofiling/Tutorial5.png" width="554" />
                    <h3>Are you having problems during the collection of ads?</h3>
                    <p>
                    <b>Facebook ads are being shown very slowly: </b> 
                    due to limitations with Facebook, the extension is only able to collect information from an ad every 30 seconds. If you have spent some minutes on Facebook already, go to another platform to collect more ads.  
                    </p>
                    <p>
                    <b>No ads or little ads are being shown in the extension:</b> reload the tab from Facebook, Twitter or LinkedIn. If the error continues try to restart the web browser. Check whether ads are being devilered to you in any of these platforms, as you may not be receiving ads in that platform.
                    </p>
                    <p>
                      <b>How do I get Google Ads?: </b> this ads are displayed in general websites rather than the web searcher. Any site can be used for this case, such as news sites.
                    </p>

                  </div>
                </div>
                <div className="panel panel-info">
                  <Divider><h2>4 - Classify Interests</h2></Divider>
                  <div className="panel-body"><strong>Estimated time</strong>: 5 - 8 minutes
                    <br />
                    Once you have seen at least 60 ads, go to the Interests Tab:
                    <br />
                    <br />
                    <img alt="Interests tab" height="151" src="https://eupoliticalbarometer.uc3m.es/overprofiling/Tutorial6.png" width="738" />
                    <br />
                    <br />
                    Complete the <b>Social Media Usage Form</b> on how often do you use each platform and how often do you browse the Internet with this browser.
                    <br />
                    <br />
                    Check the <strong>demographic data</strong>, and answer Yes or No if they are correct or not.
                    <br />
                    <br />
                    Answer from 1 to 5 stars, whether the interest is relevant to you. Answer at least <u>225 interests</u> or the 100% of interests shown to you in case there are not enough interests.
                    <br />
                    <br />
                    You should answer 1 star to interests that you don't know what they are or those you find not relevant at all.
                    <br />
                    <br />
                    <strong>Note</strong><em><strong>: </strong></em>we will check the time between each item classified, so we can tell if you have automated the process or if you are answering the questions randomly. A banner will show when we have detected that random answers are being submitted.
                  </div>
                </div>
                <div className="panel panel-info">
                  <Divider><h2>5 - Classify Ads</h2></Divider>
                  <div className="panel-body"><strong>Estimated time</strong>: 5 - 8 minutes
                    <br />
                    <br />
                    Go to Classify Ads tab:
                    <br />
                    <br />
                    <img alt="" height="136" src="https://eupoliticalbarometer.uc3m.es/overprofiling/Tutorial7.png" width="712" />
                    <br />
                    <br />
                    For each ad, click on the icon of the platform you think the ad was displayed to you, or if you don't remember to see it the "NOT SEEN - DON'T REMEMBER" button.
                    <br />
                    Also, rate the ad from 1 to 5 stars
                    <br />
                    <br />
                    <strong>Classify at least <u>50 ads</u></strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="panel panel-success">
          <Divider><h2>6 - Insert Completion Code</h2></Divider>
          <p>
            Once you have completed the three steps, go to the Info tab, and click on "Your Info". If you completed the three steps, you should see the Completion Code, which you should insert in Prolific.
          </p>
          <div>
            <br />
            <img alt="" height="340" src="https://eupoliticalbarometer.uc3m.es/overprofiling/Tutorial8b.png" width="831" />
            <br />

            <u><strong>Important: </strong>Even though the code will only appear after you complete the task, we are going to check whether you have completed all the requirements, as all information is saved on our database.</u>
            <br />
          </div>
        </div>
        {
        /*
        <div className="panel panel-success">
          <Divider><h2>Extra - Bonus study</h2></Divider>
          <p>
            We offer you an opportunity to get an extra reward. In case you would like to get the bonus, you have to do the following:
          </p>
          <ul>
            <li>
              <b>Keep the Ad extension installed for a week.</b> The bonus study will not be accepted if you re-install the extension.
            </li>
            <li>
              Use your social media accounts in that period (if your accounts are only used at the end of the week this won't be valid).
            </li>
            <li>
              Have at least <b>400 total interests.</b>
            </li>
            <li>
              Send us a message to tell us that you are interested in doing the bonus study. 
            </li>
          </ul>

          After a week, we will send you a message via Prolific to remind you to complete the following steps:

          <ul>
            <li>
              Classify 400 total interests. (150 more than the normal study)
            </li>
            <li>
              Classify 150 total ads. (100 more than the normal study)
            </li>
            <li>
              Once you have complete it, send us a message to check the study and we will send you the bonus.
            </li>
          </ul>

          The bonus task we will awarded with £4, with the possibility of adding more if you classify more interests and ads than the ones requested.
          
          <div>

          </div>
        </div>

    */}

      </div>

    <p>
      Once you have completed all steps, you could remove the extension from your browser, even though, we would recommend you to keep it until we validate your submission, for that, you should the extensions icons on the right side of the sidebar, and click on manage extensions, then search for the extension and remove it.
    </p>


    </main>
  );
}